import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { isDevelopment } from "../config/env";
import { appraisalSlice } from "../store/slices/Appraisal";
import { setLocalStorage, setSessionStorage } from "../sessionAndLocalStorage";
import { getAppraisalData } from "../store/selectors";
import { SourceSystemFactory } from "../classes/SourceSystem";

export function useGetUrlParams(location) {
  const [id, setId] = useState(null);
  const dispatch = useDispatch();
  const { appraisalSessionId } = useSelector(getAppraisalData);

  useEffect(() => {
    const { search } = location;
    const urlParams = new URLSearchParams(search);
    const id = urlParams.get("appraisalSessionId");
    const reg = urlParams.get("registration");
    const authToken = urlParams.get("data");

    if (id && authToken) {
      setLocalStorage(`_abyc_authToken_${id}`, authToken, {
        expires: 1,
        secure: isDevelopment ? false : true
      });
    }

    // ensures on mileage page there is no mismatch with appraisalSessionId and auth token passed from url vs stored in session storage
    // there seems to be an issue on mobile when users are doing multi appraisals and wrong ids are being picked up
    if (id && appraisalSessionId !== id) {
      setSessionStorage("appraisalSessionId", id);
      setId(id);
      dispatch(appraisalSlice.actions.setAppraisalSessionId(id));

      if (authToken) {
        const decodedToken = jwtDecode(authToken);
        const sourceSystemObject = new SourceSystemFactory().getSourceSystem(
          decodedToken.SourceSystemName
        );
        dispatch(
          appraisalSlice.actions.setSourceSystemData({
            sourceSystem: decodedToken.SourceSystemName,
            redirectURI: decodedToken.SourceSystemErrorUri,
            registration: reg,
            exitUri: decodedToken.SourceSystemExitUri,
            analyticSearchParam: sourceSystemObject.analyticSearchParam
          })
        );
      }
    }
  }, [dispatch, location, appraisalSessionId]);

  return id;
}
